import { Routes, Route } from "react-router-dom";
import React from "react";
import Employee from "./components/Profile";
import Login from "./components/Login";
import get_config from "./get_config.json";
import ForgotPassword from "./forms/ForgotPassword.jsx";
import ResetPassword from "./components/ResetPassword.jsx";
import ClientFeedbackForm from "./components/ClientFeedbackForm.jsx";

function InternalRoutesRenderer() {
  return (
    <div>
      <Routes>
        {/* Dynamic Student and Staff Routes */}
        {get_config.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={getElementComponent(route.element)}
          />
        ))}
      </Routes>
    </div>
  );
};

function getElementComponent(elementName) {
  switch (elementName) {
    case "Login":
      return <Login />;
    case "Employee":
      return <Employee />;
      case "ForgotPassword":
        return <ForgotPassword />;
      case "ResetPassword":
        return <ResetPassword />;
      case "ClientFeedbackForm":
        return <ClientFeedbackForm />;
    default:
      return null;
  }
}
export default InternalRoutesRenderer;




// import { Routes, Route } from "react-router-dom";
// import React from "react";
// import Employee from "./components/Profile";
// import Login from "./components/Login";

// import get_config from "./get_config.json";
// import ForgotPassword from "./forms/ForgotPassword.jsx";


// function InternalRoutesRenderer() {
//   return (
//     <div>
//       <Routes>
//         {/* Dynamic Student and Staff Routes */}
//         {get_config.map((route, index) => (
//           <Route
//             key={index}
//             path={route.path}
//             element={getElementComponent(route.element)}
//           />
//         ))}
//       </Routes>
//     </div>
//   );
// };

// function getElementComponent(elementName) {
//   switch (elementName) {
//     case "Login":
//       return <Login />;
//     case "Employee":
//       return <Employee />;
//       case "ForgotPassword":
//         return <ForgotPassword />;
//     default:
//       return null;
//   }
// }
// export default InternalRoutesRenderer;